var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoblistingFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.07,
    height: 23.074,
    viewBox: "0 0 23.07 23.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29662",
    "data-name": "Group 29662",
    transform: "translate(-511.465 -7237.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40192",
    "data-name": "Path 40192",
    d: "M6.387,18.937H9.175a3.531,3.531,0,0,0,6.846,0H27.683a.887.887,0,0,0,0-1.775H16.022a3.531,3.531,0,0,0-6.846,0H6.387a.887.887,0,0,0,0,1.775ZM12.6,16.275a1.775,1.775,0,1,1-1.775,1.775A1.775,1.775,0,0,1,12.6,16.275Z",
    transform: "translate(505.965 7238.936)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40193",
    "data-name": "Path 40193",
    d: "M6.387,14.437H18.048a3.531,3.531,0,0,0,6.846,0h2.788a.887.887,0,1,0,0-1.775H24.895a3.531,3.531,0,0,0-6.846,0H6.387a.887.887,0,1,0,0,1.775Zm15.084-2.662A1.775,1.775,0,1,1,19.7,13.55,1.775,1.775,0,0,1,21.471,11.775Z",
    transform: "translate(505.965 7235.45)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40194",
    "data-name": "Path 40194",
    d: "M6.387,9.937H9.175a3.531,3.531,0,0,0,6.846,0H27.683a.887.887,0,0,0,0-1.775H16.022a3.531,3.531,0,0,0-6.846,0H6.387a.887.887,0,0,0,0,1.775ZM12.6,7.275A1.775,1.775,0,1,1,10.824,9.05,1.775,1.775,0,0,1,12.6,7.275Z",
    transform: "translate(505.965 7231.964)",
    fill: "#d9a239"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoblistingFilterIcon);
export default __webpack_public_path__ + "static/media/joblisting_filter_icon.0d5fd8ba914ab7cde39c5b3194f348fb.svg";
export { ForwardRef as ReactComponent };